/**
 * 레벨 시스템 유틸리티 (읽기 전용)
 * 
 * 목차:
 * - calculateLevel(): 점수로부터 레벨 계산
 * - getUserLevel(): 사용자 레벨 정보 조회
 * 
 * Note: 레벨 포인트 추가 등 Write 작업은 @/utils/write/user.js 참고
 */

import { getUserLevelInfo } from "@/utils/read/user";

// ============================================
// 상수 정의
// ============================================

/**
 * 레벨 계산 기준 (100점당 1레벨)
 */
const POINTS_PER_LEVEL = 100;

// ============================================
// 레벨 계산 및 조회 (Read Only)
// ============================================

/**
 * 점수로부터 레벨 계산
 * @param {number} levelPoint - 레벨 포인트
 * @returns {number} 계산된 레벨
 */
export function calculateLevel(levelPoint) {
  return Math.floor((levelPoint || 0) / POINTS_PER_LEVEL) + 1;
}

/**
 * 사용자 레벨 정보 조회
 * @param {string} userEmail - 사용자 이메일
 * @returns {Promise<{level: number, levelPoint: number}>}
 */
export async function getUserLevel(userEmail) {
  if (!userEmail) {
    return { level: 1, levelPoint: 0 };
  }

  try {
    return await getUserLevelInfo(userEmail);
  } catch (error) {
    console.error("사용자 레벨 정보 조회 실패:", error);
    return { level: 1, levelPoint: 0 };
  }
}
